// Flavor settings MOVED to the single source of truth: src/flavors/settings.ts.
// FLAVOR_SETTING is re-exported below so existing `from 'src/data'` imports keep
// working — edit it in src/flavors/. See src/flavors/README.md.

// Index of array is type of color in planner
export const TABLE_COLORS = ['#ff7700', '#0c67e9', '#6f46a8', '#ffaf00']

export { FLAVOR_SETTING, supportsMultiDay, supportsHourlyPricing, unitPricingPeriod, resolveDurations, flavorImageDir, buildAddedUnitName } from 'src/flavors'
